const descriptions = {
  title: {
    id: 'course-authoring.textbooks.empty-placeholder.title',
    defaultMessage: 'Todavía no has añadido ningún libro de texto a este curso.',
    description: 'Message displayed when no textbooks are added to the course',
  },
  button: {
    id: 'course-authoring.textbooks.empty-placeholder.button.new-textbook',
    defaultMessage: 'Añade tu primer libro de texto',
    description: 'Text for the button to add the first textbook to the course',
  },
};

export default descriptions;
